import type { Resource } from '@/types';

type ResourceLike = Pick<Resource, 'id'> & { status?: Resource['status'] | null };

/** False only for resources explicitly marked inactive; a missing status counts as active. */
export function isActiveResource(r: ResourceLike): boolean {
  return r.status?.toLowerCase() !== 'inactive';
}

/** True for resource statuses that the resource directory considers active. */
export function isOperationallyActiveResource(r: ResourceLike): boolean {
  const status = r.status?.toLowerCase();
  return status === 'available' || status === 'busy' || status === 'active';
}

/** True for resources a planner may assign a booking to: active, and not the 'unallocated' placeholder. */
export function isAssignableResource(r: ResourceLike): boolean {
  return r.id !== 'unallocated' && isActiveResource(r);
}
